module.exports = __webpack_public_path__ + "static/img/banner_txt3.b10698b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_txt3.png
// module id = Sq5m
// module chunks = 0